/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bitgetWallet.vue?vue&type=template&id=76ec9010&scoped=true"
import script from "./bitgetWallet.vue?vue&type=script&lang=js"
export * from "./bitgetWallet.vue?vue&type=script&lang=js"
import style1 from "./bitgetWallet.vue?vue&type=style&index=1&id=76ec9010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ec9010",
  null
  
)

export default component.exports